import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    currencies: [],
    lastQuery: null,
};

const getters = {
    currencies(state) {
        return state.currencies;
    },
};

const mutations = {
    setCurrencies(state, data) {
        state.currencies = data;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },
};

const actions = {
    getCurrencyListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.currencies.length || state.lastQuery != params.query) {
            return dispatch('getCurrencies', params);
        }

        return Promise.resolve(state.currencies);
    },

    getCurrencies({ commit, dispatch }, params) {
        let route = Laroute.route('franchise.vue.currency');

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'currency_loading');

        return axios
            .get(route, options)
            .then(res => {
                commit('setCurrencies', res.data.data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'currency_loading');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'currency_loading');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/currency.js